const orderList: { name: string; uuid: string }[] = [
    { name: "Hammastarkastus", uuid: "e98fec45-97f8-11e9-bd29-02004c4f4f50" },
    { name: "Hampaan paikkaus tai lohkeaman korjaus", uuid: "3cfc8c75-98a8-11e9-bd29-02004c4f4f50" },
    { name: "Hammassärky tai -tapaturma", uuid: "03370106-5d44-11ea-a3da-02004c4f4f50" },
    { name: "Hammaskiven poisto", uuid: "41b6d7b9-2ac2-11e9-9d67-0050569b2d10" },
];

export default orderList;
